module.exports = __webpack_public_path__ + "static/ring_of_elemental_command_air-9c3a335907c188ee8f16e7a24628bb0b.jpeg";